export default __webpack_public_path__ + "static/media/blog-img217.8096dbd5.jpg";